import { DefectTypes, DefectStatusTypes } from 'Modules/types/pages/imageReview/enums'

enum ImageFilters {
  Completed = 'completed',
  Measurements = 'measurements',
  Suggestions = 'suggestions',
}

interface Sizes {
  area: {
    min: number | null
    max: number | null
  }
  length: {
    min: number | null
    max: number | null
  }
}

interface FilterState {
  subjectModel?: string[]
  aircraft?: string[]
  type?: DefectTypes[]
  severity?: DefectStatusTypes[]
  sizes?: Sizes
  inspectionDefinition?: string[]
  inspectionInstance?: string[]
  workcardDefinition?: string[]
  workcardInstance?: string[]
  inspectionImage?: string[]
  image?: ImageFilters[] //TODO consider renaming to interface?
}

type FilterQueryParams = Omit<FilterState, 'sizes'> & {
  areaMin?: string
  areaMax?: string
  lengthMin?: string
  lengthMax?: string
} & {
  [K in keyof Omit<FilterState, 'sizes'>]: string[]
}

type ArrayKeys<T> = {
  [K in keyof T]: T[K] extends any[] ? K : never
}[keyof T]

const arrayKeys: ArrayKeys<FilterState>[] = ['type', 'severity', 'inspection', 'workcard', 'image']

const getDefaultFilterState = (): FilterState => ({
  subjectModel: [],
  aircraft: [],
  type: Object.keys(DefectTypes) as DefectTypes[],
  severity: [],
  sizes: {
    area: {
      min: null,
      max: null,
    },
    length: {
      min: null,
      max: null,
    },
  },
  inspectionDefinition: [],
  inspectionInstance: [],
  workcardDefinition: [],
  workcardInstance: [],
  inspectionImage: [],
  image: [],
})

export { arrayKeys, ImageFilters, getDefaultFilterState }
export type { FilterState, FilterQueryParams, Sizes }
